<ngx-loading-bar color="#D50000" height="3px" [includeSpinner]="false"></ngx-loading-bar>

<header id="test-appHeader" class="appHeader redesigned responsive realViewport">
    <ca-header></ca-header>
</header>

<main *ngIf="!blockedUser" class="redesigned responsive realViewport">
    <router-outlet></router-outlet>
</main>

<div *ngIf="blockedUser" class="redesigned responsive realViewport">
    <div class="component-taskView unpaid">
        <div class="rd_box">
            <div class="rd_boxtitle">
                <h2>Nezaplacená služba</h2>
            </div>
            <div class="rd_boxcontent">
                <div class="col-full">
                    <p>Z důvodu nezaplacení vám byl dočasně zablokován přístup do aplikace CleverAssets.</p>
                    <p>Nemusíte se ale bát, stále vám držíme palce. Vaše smlouvy se zatím nikam neztratí. Stejně tak aktualizaci dat katastru budeme provádět i nadále.</p>
                    <p>Věříme, že se vše brzy vyřeší a po uhrazení vám službu opět zpřístupníme.</p>
                </div>
            </div>
        </div>
    </div>
</div>
